export const lastField = (s: string) => {
  const ind = s.lastIndexOf(".");
  if (ind === -1) {
    return s;
  }
  return s.slice(ind + 1);
};
